import { ClickActionChoices } from "src/app/home/models/home.model"

export const search_url_links = [ClickActionChoices.link_brand, ClickActionChoices.link_collection, ClickActionChoices.search_keywords, ClickActionChoices.product_flag];
export const path_based_links = [ClickActionChoices.link_product, ClickActionChoices.link_category, ClickActionChoices.page, ClickActionChoices.internal_page];

export const NAVIGATION_PATH_BY_CHOICE = {
  [ClickActionChoices.search_keywords]: 'search',
  [ClickActionChoices.link_brand]: 'brand',
  [ClickActionChoices.link_category]: 'category',
  [ClickActionChoices.link_collection]: 'search',
  [ClickActionChoices.link_offer]: 'search',
  [ClickActionChoices.link_product]: 'products',
  [ClickActionChoices.product_flag]: 'search',
  [ClickActionChoices.page]: 'pages',
  [ClickActionChoices.internal_page]: 'internal',
  [ClickActionChoices.link_url]: 'url',
  [ClickActionChoices.modal]: 'modal',
  [ClickActionChoices.none]: '',
}

export const SEARCH_QUERY_PARAM_KEYS = {
  [ClickActionChoices.search_keywords]: 'q',
  [ClickActionChoices.link_brand]: 'brand_id',
  [ClickActionChoices.link_collection]: 'collection_ids',
  [ClickActionChoices.product_flag]: 'tags',
  [ClickActionChoices.link_offer]: 'offer',
  [ClickActionChoices.link_category]: 'category_id',
  [ClickActionChoices.link_product]: 'product_id',
  [ClickActionChoices.link_url]: 'url',
  [ClickActionChoices.page]: 'page_id',
  [ClickActionChoices.internal_page]: 'internal_id',
  [ClickActionChoices.modal]: 'modal_id',
  [ClickActionChoices.none]: 'none'
}

export const CLICK_ACTION_FOR_FLUTTER = {
  [ClickActionChoices.link_collection]: 'link_collection',
  [ClickActionChoices.product_flag]: 'product_flag',
  [ClickActionChoices.link_url]: 'link_url',
  [ClickActionChoices.link_brand]: 'link_brand',
  [ClickActionChoices.link_product]: 'link_product',
  [ClickActionChoices.link_category]: 'link_category',
  [ClickActionChoices.search_keywords]: 'search_keyword',
  [ClickActionChoices.link_offer]: 'link_offer',
  [ClickActionChoices.page]: 'page',
  [ClickActionChoices.internal_page]: 'internal_page',
  [ClickActionChoices.modal]: 'modal',
  [ClickActionChoices.none]: 'none'
};